import React from 'react';
import { Button } from '@mui/material';
import { Check } from '@mui/icons-material';

interface CustomCheckboxProps {
  checked: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  customSx?: Object;
  variant?: 'primary' | 'secondary';
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  checked,
  onClick,
  customSx,
  variant = 'primary',
}) => {
  const isSecondary = variant === 'secondary';

  return (
    <Button
      onClick={onClick}
      sx={{
        ...{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: isSecondary ? '2px solid #2F736E' : '2px solid #162C36',
          borderRadius: '4px',
          minWidth: '20px',
          padding: 0,
          height: '20px',
          width: '20px',
          backgroundColor: isSecondary && checked ? '#2F736E' : 'transparent',
          '&:hover': {
            backgroundColor: isSecondary && checked ? '#2F736E' : 'transparent',
          },
        },
        ...customSx,
      }}
      disableRipple
    >
      <Check
        style={{
          height: '16px',
          width: '16px',
          color: isSecondary ? '#FFFFFF' : '#162C36',
          display: checked ? 'block' : 'none',
        }}
      />
    </Button>
  );
};

export default CustomCheckbox;
